import Carga from '@/model/resource/Carga'
import CargaCsvSimplificadoSemCheckComponenteSchema from '@/schema/CargaCsvSimplesSemCheckComponenteSchema.schema'

export default class CargaCsvSimplesSemCheckComponente extends Carga {

    get $schema() {
        return CargaCsvSimplificadoSemCheckComponenteSchema(this)
    }

}
